if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = JSON.parse(serializeForm(this.form));

      /*
       * POP & SHAKE M&M'S ADD-ON
       * If the M&M's checkbox is checked, add the main product
       * and the M&M's product as two separate Shopify cart items.
       */
const mmsAddon = document.querySelector('.pop-shake-addon');
const mmsQuantityInput = mmsAddon
  ? mmsAddon.querySelector('.pop-shake-addon__quantity')
  : null;

const mmsQuantity = mmsQuantityInput
  ? Math.max(0, parseInt(mmsQuantityInput.value || 0, 10))
  : 0;

if (mmsAddon && mmsQuantity > 0) {
  const mmsVariantId = parseInt(mmsAddon.dataset.mmsVariant, 10);
  const mainVariantId = parseInt(formData.id, 10);
  const quantity = parseInt(formData.quantity || 1, 10);

        config.body = JSON.stringify({
          items: [
            {
              id: mainVariantId,
              quantity: quantity
            },
            {
              id: mmsVariantId,
              quantity: mmsQuantity
            }
          ],
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname
        });
      } else {
        config.body = JSON.stringify({
          ...formData,
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname
        });
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = JSON.parse(serializeForm(this.form));

      /*
       * POP & SHAKE M&M'S ADD-ON
       * If the M&M's checkbox is checked, add the main product
       * and the M&M's product as two separate Shopify cart items.
       */
      const mmsAddon = document.querySelector('.pop-shake-addon');
      const mmsCheckbox = mmsAddon
        ? mmsAddon.querySelector('.pop-shake-addon__checkbox')
        : null;

      if (mmsAddon && mmsCheckbox && mmsCheckbox.checked) {
        const mmsVariantId = parseInt(mmsAddon.dataset.mmsVariant, 10);
        const mainVariantId = parseInt(formData.id, 10);
        const quantity = parseInt(formData.quantity || 1, 10);

        config.body = JSON.stringify({
          items: [
            {
              id: mainVariantId,
              quantity: quantity
            },
            {
              id: mmsVariantId,
              quantity: 1
            }
          ],
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname
        });
      } else {
        config.body = JSON.stringify({
          ...formData,
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname
        });
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}